import React from 'react';
import Mount from './Mount';
import Remote from './Remote';

const loader = () =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  import('communicationsDrawerAssets/AcesCommunicationsDrawer');

const FederatedModule = (props) => {
  const remoteProps = {
    loader,
    timeout: 10000,
    afterLoad: () => {
      // TODO: publish metrics
    },
    render: (loaded) => {
      if (!loaded) return <></>;
      const { mount } = loaded;

      return (
        <Mount containerId="bell-drawer" mount={mount} mountProps={props} />
      );
    },
  };

  return <Remote {...remoteProps} />;
};

export default FederatedModule;
